<button type="button" mat-button color="primary" style="background-color: rgb(232 232 232);color: rgb(36,138,227);margin-right: 8px;" (click)="onClick()">
    <span *ngIf="!isFileUploading && !isFileUploaded">{{selectFileDisplayName }}{{required ? '*':''}}</span>
    <span *ngIf="!isFileUploading && isFileUploaded">{{selectedFileDisplayName}}{{required ? '*':''}}</span>
    <span *ngIf="isFileUploading" >{{'Uploading...'}}{{required ? '*':''}}</span>
</button>
<span *ngIf="fileUploadError">Error uploading file</span>
<span id='uploadedFileName' style="padding-left: 10px; font-size:12px" class="filename-responsive">{{uploadedFileName}}</span>
<br />
<span *ngIf="fileHasScanError" style="color: red;" id="scanErrorMessage">{{scanErrorMessage}}</span>
<input [required]="required" type="file" id="fileUpload" name="fileUpload" 
   [accept]="allowedFileTypeExtensions" style="display:none;"/>
